import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  sceneInfoText: {
    fontSize: '18px',
    lineHeight: '21px',
    paddingRight: '3px',
  },
  sceneInfoTextTriple: {
    fontSize: '18px',
    lineHeight: '21px',
    paddingRight: '5px',
  },
  descriptionWrapper: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
  },
  colorBlock: {
    display: 'block',
    marginLeft: 3,
    marginRight: 5,
    width: 10,
    height: 10,
    border: '1px solid rgba(0,0,0, 0.3)',
  },
}))

export default useStyles
